// import moment from 'moment';
// import { useState, useEffect } from 'react';
// import API from 'service/api';

const HomeWorkerSchedule = () =>
{
  return (
    <div>
      <div>歡迎使用本系統</div>
      <div>本頁尚未建成，敬請期待</div>
    </div>
  );
}


/*
const today = Util.getToday();

const HomeWorkerSchedule = () =>
{
  const [schedules, setSchedules] = useState(null);
  const [tasks, setTodayTasks] = useState([]);

  useEffect(() => {
    API.getHomeData().then(resp => {
      if (resp.success) {
        let schedules = resp.msg.map(x => {
          let date = new Date(x.l_date);
          return {...x
            ,date
            ,id: `${x.cd_license}-${x.loc_key}-${date.valueOf()}`
            ,title:  x.cd_license
            ,allDay: 1
          };
        });
        setSchedules(schedules);

        let tasks = schedules.filter(x => x.date.valueOf() == today.valueOf());
        setTodayTasks(tasks);

      }
    });
  }, []);

  return (
    <>
      <div classNmae="today">{moment().format('YYYY年M月D日 星期ddd')}</div>
      <h1>今天的工作</h1>
      <div className="wkrv-today-tasks">
        <table className="data-table full-width">
          <colgroup>
            <col width="80px"  id="col-wkr-task-loc-key" />
            <col width="220px" id="col-wkr-task-loc-name" />
            <col width="40px"  id="col-wkr-task-service" />
            <col width="80px"  id="col-wkr-task-license" />
            <col width="80px"  id="col-wkr-task-floor" />
            <col width="80px"  id="col-wkr-task-psn" />
            <col width="60px"  id="col-wkr-task-waxing" />
            <col width="auto"  id="col-wkr-task-remarks" />
          </colgroup>
          <thead>
            <tr>
              <th className="col-wkr-task-loc-key">地點編號</th>
              <th className="col-wkr-task-loc-name">地點名稱</th>
              <th className="col-wkr-task-service">計劃</th>
              <th className="col-wkr-task-license">車牌</th>
              <th className="col-wkr-task-floor">樓層</th>
              <th className="col-wkr-task-psn">車位</th>
              <th className="col-wkr-task-waxing">打蠟</th>
              <th className="col-wkr-task-remarks">備註</th>
            </tr>
          </thead>
          <tbody>
            { !tasks.length
              ? <p className="message blue">今日沒有工作</p>
              : tasks.map(t =>
                  <tr key={t.cd_license}>
                    <td className="col-wkr-task-loc-key">{ t.loc_key }</td>
                    <td className="col-wkr-task-loc-name">{ t.loc_name }</td>
                    <td className="col-wkr-task-service">{ t.srv_plan }</td>
                    <td className="col-wkr-task-license">{ t.cd_license }</td>
                    <td className="col-wkr-task-floor">{ t.srv_floor }</td>
                    <td className="col-wkr-task-psn">{ t.srv_psn }</td>
                    <td className="col-wkr-task-waxing">{ !!t.waxing && '是' }</td>
                    <td className="col-wkr-task-remarks">{ t.remarks }</td>
                  </tr>
                )
            }
          </tbody>
        </table>
      </div>
    </>
  );
}
*/

export default HomeWorkerSchedule;